import { Button, Loader } from '@plaidev/sour-react';
import type { ReactElement } from 'react';
import { FormProvider } from 'react-hook-form';

import { AnalyzingStep } from './sections/AnalyzingStep';
import { ConfigureStep } from './sections/ConfigureStep';
import { UploadStep } from './sections/UploadStep';
import { useTableDefinitionNewPage } from './useTableDefinitionNewPage';

export function TableDefinitionNewPage(): ReactElement {
  const {
    methods,
    onSubmit,
    sourcesPending,
    isSystemAdmin,
    navigateToList,
    createMutation,
    analyzeFlow,
    sourceSystem,
    sourceSystemId,
    columnEditor,
  } = useTableDefinitionNewPage();

  if (sourcesPending) {
    return (
      <div className="flex justify-center py-16">
        <div className="relative size-12">
          <Loader />
        </div>
      </div>
    );
  }

  const { step, thinking, analysis, uploadMutation, uploadItems, selectedFile, uploadProgress, analyzeModelId, setAnalyzeModelId } =
    analyzeFlow;

  return (
    <FormProvider {...methods}>
      <form
        className={`mx-auto flex flex-col gap-8 pb-16 ${step === 'configure' ? 'max-w-6xl' : 'max-w-3xl'}`}
        onSubmit={(e) => void onSubmit(e)}
      >
        <div className="flex flex-wrap justify-between gap-4">
          <h1 className="text-xl font-semibold text-default">
            テーブル定義の作成
            {step === 'upload' ? (
              <span className="mt-0.5 block text-sm font-normal text-muted-light sm:mt-0 sm:ml-2 sm:inline">（LLM解析前）</span>
            ) : null}
          </h1>
          <Button type="button" variant="basic" size="sm" onClick={analyzeFlow.handleHeaderNavigateAway}>
            {step === 'upload' ? '戻る' : 'キャンセル'}
          </Button>
        </div>

        {step === 'upload' ? (
          <UploadStep
            sourceSystemSelectOptions={sourceSystem.sourceSystemSelectOptions}
            sourceSystemId={sourceSystemId ?? ''}
            uploadItems={uploadItems}
            onSelectFiles={analyzeFlow.handleSelectFiles}
            onDeleteUpload={analyzeFlow.handleDeleteUpload}
            uploadMutationIsPending={uploadMutation.isPending}
            uploadProgress={uploadProgress}
            selectedFile={selectedFile}
            onStartUpload={() => void analyzeFlow.handleStartUpload()}
            navigateToList={navigateToList}
            isSystemAdmin={isSystemAdmin}
            analyzeModelId={analyzeModelId}
            onAnalyzeModelIdChange={setAnalyzeModelId}
          />
        ) : null}

        {step === 'analyzing' ? <AnalyzingStep thinking={thinking} /> : null}

        {step === 'configure' && analysis ? (
          <ConfigureStep
            editor={columnEditor}
            analysis={analysis}
            isSystemAdmin={isSystemAdmin}
            selectedSourceSystemName={sourceSystem.selectedSourceSystemName}
            createMutationIsPending={createMutation.isPending}
            isValid={methods.formState.isValid}
            navigateToList={navigateToList}
          />
        ) : null}
      </form>
    </FormProvider>
  );
}
